import { createContext, useContext } from 'react';
export var PopoverContext = /*#__PURE__*/createContext({});
export var usePopoverContext = function () {
  return useContext(PopoverContext);
};